<template>
  <div class="crate-label">
    {{ customername }}
    <br>
    {{ date }} -  <b style="font-size: 75%; background-color: #eee">{{ city }}</b>
  </div>
</template>

<script>

export default {
  name: "CrateLabel",
  components: {},
  props: ['customername', 'date','city'],
  data() {
    return {};
  },
  mounted() {
    window.print();
    // tab sluiten na printen
    window.onafterprint = function () {  window.close() };
  },
}

</script>

<style>
@media print {

  @page {
    /* default size/orientation for printing, not working on ipad */
    size: 90mm 38mm landscape;
  }

  .crate-label {
    font-size: 1.4rem;
  }

  body {
    background-color: white !important;
  }

  #container {
    max-width: initial !important;
    box-shadow: none !important;
  }

  .toolbar {
    display: none !important;
  }

  #header {
    display: none;
  }
}
</style>
